<template>
  <div>
    <breadcrumb class="pl-2 mt-2" />
    <BenefitList :benefits="getBenefits" />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Breadcrumb from "@/components/General/Breadcrumb";
import BenefitList from "@/components/Benefits/BenefitList";
import axios from "axios";
export default {
  components: {
    Breadcrumb,
    BenefitList
  },
  computed: {
    ...mapGetters("benefits", ["getBenefits"]),
    ...mapState("user", ["current_user"])
  },
  mounted() {
    window.scrollTo(0, 0);

    this.fetchBenefits(localStorage.getItem("view_as"))
  },
  methods: {
    ...mapActions("benefits", ["fetchBenefits"])
  }
};
</script>
<style lang="css">
@media screen and (min-width: 300px) and (max-width: 425px) {
  .select-category > .v-text-field.v-text-field--enclosed .v-text-field__details, 
  .select-category > .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
    margin: 0;
    max-height: 38px;
    min-height: 38px !important;
    display: flex!important;
    align-items: center!important
  }

  .select-category > .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    border-radius: 6px;
  }
}
</style>